module.exports = __webpack_public_path__ + "static/media/Major Project EXTC 2016-17.6d2531c8.pdf";